import { faDraftingCompass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'assets/theme';
import React from 'react';

interface IDrawingToolbarProps {
	toggleDrawingToolbar: (ciq: any) => void,
	ciq: any,
	showDrawingToolbar: boolean
}

export const DrawingToolbar: React.FunctionComponent<IDrawingToolbarProps> = ({toggleDrawingToolbar, ciq, showDrawingToolbar}) => {
	if (!ciq) {
		return <div />;
	}

	const toggleDrawingClickHandler = () => {
		toggleDrawingToolbar(ciq);
	};

	return (
		<DrawingToolbarButton active={showDrawingToolbar} onClick={toggleDrawingClickHandler}>
			<FontAwesomeIcon style={{ cursor: 'pointer' }} size="1x" icon={faDraftingCompass} />
		</DrawingToolbarButton>
	);
};

const DrawingToolbarButton = styled.button<{ active: boolean }>`
	height: 27px;
	width: 27px;
	opacity: .6;
	transition: opacity .20s 0s;
	border-width: 1px;
	border-color: ${({ theme }) => theme.core.textColor};
	border-style: ${({ active }) => active ? 'solid' : 'none'};
	:focus {
		border-color: ${({ theme }) => theme.core.textColor};
		border-style: ${({ active }) => active ? 'solid' : 'none'};
	}
`